import { Injectable } from '@angular/core';

import { Portal } from 'src/models/portals';

import { GenericObjectsService } from './generic-objects.service';

@Injectable({
  providedIn: 'root',
})
export class PortalsService extends GenericObjectsService<Portal> {
  protected baseUrl = '/portals';

  update(id: string, payload: Partial<Portal>): Promise<Portal> {
    return this.apiService.patchPromise<Portal>(`${this.baseUrl}/${id}`, payload);
  }
}
